import './ButtonClear.scss'
import classnames from 'classnames'

export const ButtonClear = ({
  handleClear,
  clearCartTitle,
  isRecommendedForYou
}) => {
  return (
    <div
      className={classnames('cart-header__button-clear', {
        recommended: isRecommendedForYou
      })}
      onClick={handleClear}>
      {clearCartTitle}
    </div>
  )
}
